import { HttpStatus } from '@/common/network/constants/httpStatus';

export default class QueryResult<T = Record<string, unknown>> {
  content!: T;
  networkResponse?: Response;
  cacheHit = false;

  static fromContent<T>(content: T) {
    const result = new QueryResult<T>();

    result.content = content;
    result.cacheHit = true;

    return result;
  }

  // temporal getter for supporting old interface
  // @deprecated
  get data() {
    return this.content;
  }

  // temporal getter for supporting old interface
  // @deprecated
  get ok() {
    return this.cacheHit || this.networkResponse?.ok;
  }

  get status(): HttpStatus | undefined {
    return this.cacheHit ? HttpStatus.OK : this.networkResponse?.status;
  }

  get filename() {
    const contentDisposition = this.networkResponse?.headers.get('Content-Disposition');
    const [, filename] = contentDisposition?.split('filename=') ?? [];

    return filename;
  }
}
